











































import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		openPopInEditNotAvailable: {
			type: Boolean,
			default: false
		},
		isPrescription: {
			type: Boolean,
			default: true
		},
		needOtherInjection: {
			type: Boolean,
			default: false
		}
	}
});

@Component({
	model: {
		prop: 'openPopInEditNotAvailable',
		event: 'change'
	}
})
export default class PopinEditNotAvailable extends Props {
	get computedValue(): boolean {
		return this.openPopInEditNotAvailable;
	}

	set computedValue(value: boolean) {
		this.$emit('change', value);
	}
}
